/* tslint:disable */
/* eslint-disable */
/**
 * SISCC Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum MenuNodeType {
    Item = 'Item',
    Menu = 'Menu',
    Separator = 'Separator',
    Subgroup = 'Subgroup'
}

export function MenuNodeTypeFromJSON(json: any): MenuNodeType {
    return MenuNodeTypeFromJSONTyped(json, false);
}

export function MenuNodeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuNodeType {
    return json as MenuNodeType;
}

export function MenuNodeTypeToJSON(value?: MenuNodeType | null): any {
    return value as any;
}

